<div [id]="id() + '-card'" class="card">
    @if (customHeader()) {
        <ng-content select="[customHeader]"></ng-content>
    } @else if (header()) {
        <p class="card-header">
            @if (icon()) {
                <span aria-hidden="true">
                    <i [class]="icon()" [style.color]="iconColor()"></i>
                </span>
            }
            <span class="title"> {{ header() | translate }}</span>
        </p>
    }

    <ng-content></ng-content>
</div>
